export default class CreditLineModel {
    constructor (
        _code = "", 
        _name = "",
        _description = "",
        _term = "",
        _rate = 0,
        _status = { code: 1}
    ){
        
        this.code = _code; 
        this.name = _name;
        this.description = _description;
        this.term = _term;
        this.rate = _rate;
        this.status = _status;

    }
}
  